// extracted by mini-css-extract-plugin
export default {"headerRow":"headerRow--fCsgz","buttonRow":"buttonRow--XCgcq","commentEntry":"commentEntry--_oZNm","saveCommentButton":"saveCommentButton--IdF3d"};